import React, { useState } from 'react';
import SurveyForm2 from "../surveyform2/survey_form_2"; // import your survey form
import './Section_4.css';


function Section4({ sectionConfig, onOpenSurvey }) {

  const [showSurvey, setShowSurvey] = useState(false);
  const handleCloseSurvey = () => {
      setShowSurvey(false);
    };

  if (!sectionConfig || !sectionConfig.steps) return null;

  const indicatorColors = ['#007bff', '#28a745', '#ffc107', '#17a2b8', '#dc3545'];

  return (
    <>
    <section className="section-4">
      <h2 className="section-4-title">{sectionConfig.title}</h2>

      <div className="steps-wrapper">
        {/* Single Gradient Horizontal Line */}
        <div className="steps-line"></div>

        <div className="steps-sequence">
          {sectionConfig.steps.map((step, idx) => (
            <div key={idx} className="step">
              <div
                className="step-indicator"
                style={{ backgroundColor: indicatorColors[idx % indicatorColors.length] }}
              >
                {idx + 1}
              </div>
              <div className="step-details">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-subtitle">{step.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
{/* Survey modal */}
      {showSurvey && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={handleCloseSurvey}>
              ✖
            </button>
            <SurveyForm2 />
          </div>
        </div>
      )}
    </>
  );
}


export default Section4;